import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddComment = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.455 19L2 22.5V4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V18C22 18.5523 21.5523 19 21 19H6.455ZM11 10H8V12H11V15H13V12H16V10H13V7H11V10Z",
		fill: "currentColor"
	})
});
export default SvgAddComment;
